import React, { useState } from 'react';
import { User, Lock, ArrowRight, Eye, EyeOff, Globe, ChevronDown } from 'lucide-react';
import { db } from '../firebase'; 
import { ref, get } from "firebase/database"; 
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import './Register.css'; 
import './Login.css'; 

const Login = () => {
    const { t, i18n } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const [showLangMenu, setShowLangMenu] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const languages = [
        { code: 'en', flag: '🇺🇸', label: 'EN' }, 
        { code: 'es', flag: '🇪🇸', label: 'ES' }, 
        { code: 'fa', flag: '🇮🇷', label: 'FA' }, 
        { code: 'ar', flag: '🇸🇦', label: 'AR' }, 
        { code: 'tr', flag: '🇹🇷', label: 'TR' }
    ];

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!username || !password) {
            Swal.fire({ icon: 'warning', title: t('empty_fields'), text: t('empty_text') });
            return;
        }

        try {
            Swal.fire({ title: t('verifying'), didOpen: () => { Swal.showLoading() }, allowOutsideClick: false });
            const userRef = ref(db, 'users/' + username);
            const snapshot = await get(userRef);

            if (snapshot.exists()) {
                const userData = snapshot.val();
                if (userData.password === password) {
                    localStorage.setItem('user', JSON.stringify(userData));
                    Swal.fire({ icon: 'success', title: t('success_title'), text: `${t('success_text')} ${username}!`, timer: 1500, showConfirmButton: false });
                    setTimeout(() => { window.location.href = "/mine"; }, 1500);
                } else {
                    Swal.close();
                    Swal.fire({ icon: 'error', title: t('error_title'), text: t('error_text') });
                }
            } else {
                Swal.close();
                Swal.fire({ icon: 'error', title: t('not_found'), text: t('not_found_text') });
            }
        } catch (error) {
            Swal.close();
            Swal.fire({ icon: 'error', title: 'Error', text: 'Connection failed: ' + error.message });
        }
    };

    return (
        <div className="reg-container">
            <div className="reg-card" style={{ position: 'relative' }}>
                <div className="lang-container" style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 10 }}>
                    <button className="lang-btn" onClick={() => setShowLangMenu(!showLangMenu)} style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                        <Globe size={16} /> <span>{i18n.language.toUpperCase()}</span> <ChevronDown size={14} />
                    </button>
                    {showLangMenu && (
                        <div className="lang-dropdown" style={{ position: 'absolute', top: '100%', right: '0', background: 'white', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', zIndex: 20 }}>
                            {languages.map((l) => (
                                <div key={l.code} className="lang-option" onClick={() => { i18n.changeLanguage(l.code); setShowLangMenu(false); }} style={{ cursor: 'pointer', padding: '5px', display: 'flex', gap: '5px' }}>
                                    <span>{l.flag}</span> {l.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="reg-header">
                    <h1>{t('welcome')}</h1>
                    <p>{t('subtitle')}</p>
                </div>

                <form className="reg-form" onSubmit={handleLogin}>
                    <div className="input-group">
                        <label>{t('username')}</label>
                        <div className="input-wrapper">
                            <User size={18} className="input-icon" />
                            <input type="text" placeholder={t('placeholder_user')} value={username} onChange={(e) => setUsername(e.target.value)} required />
                        </div>
                    </div>

                    <div className="input-group">
                        <label>{t('password')}</label>
                        <div className="input-wrapper">
                            <Lock size={18} className="input-icon" />
                            <input type={showPassword ? "text" : "password"} placeholder={t('placeholder_pass')} value={password} onChange={(e) => setPassword(e.target.value)} required />
                            <button type="button" className="eye-toggle" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="reg-btn" style={{ marginTop: '20px' }}>
                        {t('login_btn')} <ArrowRight size={18} />
                    </button>
                </form>

                <div className="reg-footer">
                    <p>{t('no_account')} <a href="/register">{t('create_acc')}</a></p>
                </div>
            </div>
        </div>
    );
};

export default Login;